import ApiError from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiError";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import LazoAuthService from "@/services/LazoAuthService";
import LazoCustomAuthControllerV2Service from "@/services/LazoCustomAuthControllerV2Service";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const AUTH_QUERY_KEY = "auth";

// ========== MUTATIONS ==========

export function useForgotPassword() {
  const { t } = useTranslation("auth");

  return useMutation({
    mutationFn: (email: string) => LazoCustomAuthControllerV2Service.forgotPassword(email).then((r) => r.getContentOrThrowError()),
    mutationKey: [AUTH_QUERY_KEY, "forgot-password"],
    meta: {
      errorMessage: t("forgotPassword.errors.resetError"),
      successMessage: t("forgotPassword.success.emailSent"),
    },
  });
}

export function useLogout() {
  return useMutation({
    mutationFn: () => LazoAuthService.logout().then((r) => r.getContentOrThrowError()),
    mutationKey: [AUTH_QUERY_KEY, "logout"],
    meta: {
      errorMessage: "Could not log out",
    },
  });
}

export function useRequestMagicLink() {
  return useMutation({
    mutationFn: ({ email, redirect }: { email: string; redirect?: string }) =>
      LazoAuthService.requestMagicLink(email, redirect).then((r) => r.getContentOrThrowError()),
    mutationKey: [AUTH_QUERY_KEY, "magic-link"],
    onError: (error: unknown) => {
      if (error instanceof ApiError) {
        NotificationService.warn(error.message);
      } else {
        NotificationService.error("Something went wrong. Please try again.");
      }
    },
  });
}
